import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            <li>
              <Link to="/dashboard" className=" ">
                <i className="bx bxs-dashboard"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-dollar-circle"></i>
                <span>{props.t("Sales")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/add-sales">{props.t("New Sales Entry")}</Link>
                </li>
                <li>
                  <Link to="/view-sales-entries">{props.t("Sales Entries")}</Link>
                </li>
                {/*<li>
                  <Link to="/add-sales-payment">{props.t("New Payment/Receipt")}</Link>
                </li>
                <li>
                  <Link to="/view-sales-receipts">{props.t("Sales Receipts")}</Link>
                </li>*/}
                
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-shopping-bag"></i>
                <span>{props.t("Purchase")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/add-purchase">{props.t("Add Purchase Entry")}</Link>
                </li>
                <li>
                  <Link to="/view-purchase-entries">{props.t("Purchase Entries")}</Link>
                </li>
                {/**
                <li>
                  <Link to="/add-purchase-payment">{props.t("Add Purchase Payment")}</Link>
                </li>
                <li>
                  <Link to="/view-purchase-payments">{props.t("Purchase Payments")}</Link>
                </li>
                <li>
                  <hr className="m-0 p-0"/>
                </li>
                <li>
                  <Link to="/add-expense-payment">{props.t("Add Expense Payment")}</Link>
                </li>
                <li>
                  <Link to="/list-expenses">{props.t("Expenses")}</Link>
                </li>
                 */}
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-receipt"></i>
                <span>{props.t("Payments & Receipts")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/add-sales-payment">{props.t("Add Sales Payment")}</Link>
                </li>
                <li>
                  <Link to="/add-purchase-payment">{props.t("Add Purchase Payment")}</Link>
                </li>
                <li>
                  <Link to="/add-expense-payment">{props.t("Add Expense Payment")}</Link>
                </li>
                <li>
                  <Link to="/add-cash-input">{props.t("Add Cash Input")}</Link>
                </li>
                <li>
                  <hr className="m-0 p-0"/>
                </li>
                <li>
                  <Link to="/view-sales-receipts">{props.t("Sales Receipts")}</Link>
                </li>
                <li>
                  <Link to="/view-purchase-payments">{props.t("Purchase Payments")}</Link>
                </li>
                <li>
                  <Link to="/list-expenses">{props.t("Expenses")}</Link>
                </li>
                <li>
                  <Link to="/list-cash-input">{props.t("Cash Inputs")}</Link>
                </li>
                
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("Products")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/view-products">{props.t("View Products")}</Link>
                </li>
                <li>
                  <Link to="/add-product">
                    {props.t("Add Product")}
                  </Link>
                </li>
                <li>
                  <Link to="/price-tags">
                    {props.t("Price Tag")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-user-detail"></i>
                <span>{props.t("Manage")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/list-customer">{props.t("Customers")}</Link>
                </li>
                <li>
                  <Link to="/list-supplier">{props.t("Suppliers")}</Link>
                </li>
                <li>
                  <Link to="/list-employee">{props.t("Employees")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-book-content"></i>
                <span>{props.t("Accounting")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/list-coa">{props.t("Chart of Accounts")}</Link>
                </li>
                <li>
                  <Link to="/list-banks">{props.t("Banks/Cash")}</Link>
                </li>
              </ul>
            </li>
            

            <li>
              <Link to="/all-reports" className=" ">
                <i className="bx bxs-bar-chart-alt-2"></i>
                <span>{props.t("Reports")}</span>
              </Link>
            </li>

            <li>
              <Link to="/all-settings" className=" ">
                <i className="bx bx-cog"></i>
                <span>{props.t("Settings")}</span>
              </Link>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
